import { useCallback, useEffect, useState } from 'react';
import { chatService } from '../services/chatService';

export function useChatStore() {
  const [snapshot, setSnapshot] = useState(chatService.getSnapshot);

  useEffect(() => {
    const sync = () => setSnapshot(chatService.getSnapshot());
    const unsubscribe = chatService.subscribe(sync);
    chatService.ensureConnected();
    sync();
    return () => {
      unsubscribe();
    };
  }, []);

  const refreshThreads = useCallback(() => chatService.refreshThreads(), []);
  const loadThreadMessages = useCallback(
    (threadId: number, options?: { beforeId?: number; limit?: number; refresh?: boolean }) =>
      chatService.loadThreadMessages(threadId, options),
    [],
  );
  const markThreadRead = useCallback((threadId: number) => chatService.markThreadRead(threadId), []);
  const sendMessage = useCallback(
    (body: string, recipientUserId?: number | null) => chatService.sendMessage(body, recipientUserId),
    [],
  );
  const setActiveThread = useCallback(
    (threadId: number | null, recipient?: { userId?: number | null; email?: string | null }) =>
      chatService.setActiveThread(threadId, recipient),
    [],
  );
  const clearError = useCallback(() => chatService.clearError(), []);

  return {
    ...snapshot,
    refreshThreads,
    loadThreadMessages,
    markThreadRead,
    sendMessage,
    setActiveThread,
    clearError,
  };
}
